<template>
  <div class="audio-thumbnail">
    <v-card-media
      v-if="media.poster && media.poster.thumbnailUrl"
      :src="media.poster.thumbnailUrl"
      :style="{ width: width + 'px' }"
      :height="height"></v-card-media>

    <audio-default-thumbnail
      v-else
      :width="width"
      class="default"
    ></audio-default-thumbnail>
  </div>
</template>

<script>

import AudioDefaultThumbnail from '@/components/AudioDefaultThumbnail';
import CalcHeightMixin from '@/mixins/CalcHeightMixin';

export default {
  name: 'audio-thumbnail',
  components: {
    AudioDefaultThumbnail,
  },
  mixins: [CalcHeightMixin],
  props: {
    media: {
      type: Object,
      required: true,
    },
    width: {
      default: 200,
    },
  },
};

</script>

<style scoped>

.audio-thumbnail {
  position: relative;
}

.default {
  position: relative;
  background: #fcfcfc;
}
</style>



// WEBPACK FOOTER //
// src/components/AudioThumbnail.vue